var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAttachment(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.09375 15.1562C0.28125 13.3438 0.28125 10.4062 2.09375 8.59375L9.125 1.5625C10.5312 0.15625 12.7812 0.15625 14.1875 1.5625C15.5938 2.96875 15.5938 5.21875 14.1875 6.625L8.25 12.5312C7.28125 13.5312 5.6875 13.5312 4.71875 12.5312C3.71875 11.5625 3.71875 9.96875 4.71875 8.96875L9.71875 3.96875C9.875 3.8125 10.0938 3.8125 10.25 3.96875L10.7812 4.5C10.9375 4.65625 10.9375 4.875 10.7812 5.03125L5.75 10.0312C5.375 10.4375 5.375 11.0938 5.75 11.4688C6.15625 11.875 6.8125 11.875 7.21875 11.4688L13.125 5.5625C13.9375 4.75 13.9375 3.4375 13.125 2.625C12.3125 1.8125 11 1.8125 10.1875 2.625L3.15625 9.65625C1.9375 10.875 1.9375 12.875 3.15625 14.0938C4.375 15.3125 6.375 15.3125 7.59375 14.0938C9.65625 12.0312 11.6562 10.0312 13.7188 7.96875C13.875 7.8125 14.0938 7.8125 14.25 7.96875L14.7812 8.5C14.9375 8.65625 14.9375 8.875 14.7812 9.03125C12.7188 11.0938 10.7188 13.0938 8.65625 15.1562C6.84375 16.9688 3.90625 16.9688 2.09375 15.1562Z",
    fill: "#333333"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAttachment);
export default __webpack_public_path__ + "static/media/attachment.50a566e26e9a10eed0c72b31672be09b.svg";
export { ForwardRef as ReactComponent };